import './style.css';


import { withWidth } from '@material-ui/core';
import { useEffect, useState } from 'react';
import { Box, Typography } from '@mui/material';

function PersonalBrandAnimate({ width, ...props }) {
  const index = props.index;

  const [scale, setScale] = useState(0);
  // console.log(width);
  const sizes = { xs: 40, sm: 40, md: 40, lg: 45, xl: 48 };
  useEffect(() => {
    setScale(sizes[width]);
  }, [width]);

  const [scaleStep3, setScaleStep3] = useState(0.5);

  const [intervalId, setIntervalId] = useState(null);
  const [unicornRatio, setunicornRatio] = useState({ ratio: 33, worth: '323M' });
  useEffect(() => {
    // personal brand asset scale index + scaleArray:
    let i = 1,
      scaleArray = [0.5, 0.7, 0.9];
    // unicorn graph scale unicornRatio + ratioArray:
    const ratioArray = [
      { ratio: 100, worth: '$1B' },
      { ratio: 33, worth: '$323M' },
      { ratio: 66, worth: '$654M' },
    ];

    if (index === 1 && intervalId === null) {
      const id = setInterval(() => {
        // personal brand asset:
        setScaleStep3(scaleArray[i % 3]);
        i++;
        // unicorn graph:
        setunicornRatio(ratioArray[i % 3]);
      }, 1000);
      setIntervalId(id);
    } else if (index !== 1 && intervalId !== null) {
      clearInterval(intervalId);
      setIntervalId(null);
    }
  }, [index, intervalId]);

  let index4WidthAsset = 0.68;
  const socialMediaContainerCordinate = [
    {
      position: 'absolute',
      bottom: scale * -0.8,
      left: '155%',
      transform: 'translate(-50%,0)',
      width: scale * 4,
    },

    {
      position: 'absolute',
      bottom: scale * 0 * scaleStep3,
      left: '50%',
      transform: 'translate(-50%,0)',
      width: scale * 4 * scaleStep3,
    },
    {
      position: 'absolute',
      bottom: scale * -0.75,
      left: '35%',
      transform: 'translate(-50%,0)',
      width: scale * 4,
    },
    {
      position: 'absolute',
      bottom: scale * -0.98 * index4WidthAsset,
      left: scale * -6 * index4WidthAsset,
      transform: 'translate(-50%,0)',
      width: scale * 4 * index4WidthAsset,
    },
  ];

  const profilePicEmptyCordinate = [
    {
      position: 'absolute',
      bottom: scale * 0.55,
      left: '50%',
      transform: 'translate(-50%,0)',
      width: scale * 3,
    },

    {
      position: 'absolute',
      bottom: scale * 0.55 * scaleStep3,
      left: '50%',
      transform: 'translate(-50%,0)',
      width: scale * 3 * scaleStep3,
    },
    {
      position: 'absolute',
      bottom: scale * 0.55,
      left: '50%',
      transform: 'translate(-50%,0)',
      width: scale * 3,
    },
    {
      position: 'absolute',
      bottom: scale * 0.55 * index4WidthAsset,
      left: '50%',
      transform: 'translate(-50%,0)',
      width: scale * 3 * index4WidthAsset,
    },
  ];
  const usernameHandleCordinate = [
    {
      position: 'absolute',
      bottom: scale * 0,
      left: '50%',
      transform: 'translate(-50%,0)',
      width: scale * 3,
    },

    {
      position: 'absolute',
      bottom: scale * 0 * scaleStep3,
      left: '50%',
      transform: 'translate(-50%,0)',
      width: scale * 3 * scaleStep3,
    },
    {
      position: 'absolute',
      bottom: scale * 0,
      left: '50%',
      transform: 'translate(-50%,0)',
      width: scale * 3,
    },
    {
      position: 'absolute',
      bottom: scale * 0 * index4WidthAsset,
      left: '50%',
      transform: 'translate(-50%,0)',
      width: scale * 3 * index4WidthAsset,
    },
  ];
  const TiktokIconCordinate = [
    {
      position: 'absolute',
      bottom: scale * 0.74,
      left: scale * -0.05,
      width: scale * 0.53,
    },

    {
      position: 'absolute',
      bottom: scale * -0.68 * scaleStep3,
      left: scale * 0.06 * scaleStep3,
      width: scale * 0.4 * scaleStep3,
    },
    {
      position: 'absolute',
      bottom: scale * -0.68,
      left: scale * 0.06,
      width: scale * 0.4,
    },
    {
      position: 'absolute',
      bottom: scale * -0.68 * index4WidthAsset,
      left: scale * 0.06 * index4WidthAsset,
      width: scale * 0.4 * index4WidthAsset,
    },
  ];
  const YoutubeIconCordinate = [
    {
      position: 'absolute',
      bottom: scale * 2.1,
      left: scale * -0.45,
      width: scale * 0.65,
    },

    {
      position: 'absolute',
      bottom: scale * -0.68 * scaleStep3,
      left: scale * 1.27 * scaleStep3,
      width: scale * 0.465 * scaleStep3,
    },
    {
      position: 'absolute',
      bottom: scale * -0.68,
      left: scale * 1.27,
      width: scale * 0.465,
    },
    {
      position: 'absolute',
      bottom: scale * -0.68 * index4WidthAsset,
      left: scale * 1.27 * index4WidthAsset,
      width: scale * 0.465 * index4WidthAsset,
    },
  ];
  const SnapchatIconCordinate = [
    {
      position: 'absolute',
      bottom: scale * 3.35,
      left: scale * 0.1,
      width: scale * 0.68,
    },

    {
      position: 'absolute',
      bottom: scale * -0.71 * scaleStep3,
      left: scale * 0.59 * scaleStep3,
      width: scale * 0.47 * scaleStep3,
    },
    {
      position: 'absolute',
      bottom: scale * -0.71,
      left: scale * 0.59,
      width: scale * 0.47,
    },
    {
      position: 'absolute',
      bottom: scale * -0.71 * index4WidthAsset,
      left: scale * 0.59 * index4WidthAsset,
      width: scale * 0.47 * index4WidthAsset,
    },
  ];
  const instagramIconCordinate = [
    {
      position: 'absolute',
      bottom: scale * 3.87,
      left: '50%',
      transform: 'translate(-50%,0)',
      width: scale * 0.68,
    },

    {
      position: 'absolute',
      bottom: scale * -0.71 * scaleStep3,
      left: scale * 1.93 * scaleStep3,
      width: scale * 0.45 * scaleStep3,
    },
    {
      position: 'absolute',
      bottom: scale * -0.71,
      left: scale * 1.93,
      width: scale * 0.45,
    },
    {
      position: 'absolute',
      bottom: scale * -0.71 * index4WidthAsset,
      left: scale * 1.93 * index4WidthAsset,
      width: scale * 0.45 * index4WidthAsset,
    },
  ];
  const XIconCordinate = [
    {
      position: 'absolute',
      bottom: scale * 3.35,
      left: scale * 3.35,
      width: scale * 0.56,
    },

    {
      position: 'absolute',
      bottom: scale * -0.68 * scaleStep3,
      left: scale * 3.058 * scaleStep3,
      width: scale * 0.39 * scaleStep3,
    },
    {
      position: 'absolute',
      bottom: scale * -0.68,
      left: scale * 3.058,
      width: scale * 0.39,
    },
    {
      position: 'absolute',
      bottom: scale * -0.68 * index4WidthAsset,
      left: scale * 3.058 * index4WidthAsset,
      width: scale * 0.39 * index4WidthAsset,
    },
  ];
  const FacebookIconCordinate = [
    {
      position: 'absolute',
      bottom: scale * 1.92,
      left: scale * 3.83,
      width: scale * 0.35,
    },

    {
      position: 'absolute',
      bottom: scale * -0.7 * scaleStep3,
      left: scale * 2.6 * scaleStep3,
      width: scale * 0.23 * scaleStep3,
    },
    {
      position: 'absolute',
      bottom: scale * -0.7,
      left: scale * 2.6,
      width: scale * 0.23,
    },
    {
      position: 'absolute',
      bottom: scale * -0.7 * index4WidthAsset,
      left: scale * 2.6 * index4WidthAsset,
      width: scale * 0.23 * index4WidthAsset,
    },
  ];
  const SocialIconCordinate = [
    {
      position: 'absolute',
      bottom: scale * 0.74,
      left: scale * 3.65,
      width: scale * 0.55,
    },

    {
      position: 'absolute',
      bottom: scale * -0.73 * scaleStep3,
      left: scale * 3.64 * scaleStep3,
      width: scale * 0.39 * scaleStep3,
    },
    {
      position: 'absolute',
      bottom: scale * -0.73,
      left: scale * 3.64,
      width: scale * 0.39,
    },
    {
      position: 'absolute',
      bottom: scale * -0.73 * index4WidthAsset,
      left: scale * 3.64 * index4WidthAsset,
      width: scale * 0.39 * index4WidthAsset,
    },
  ];
  const ProfileTradeMarkIconCordinate = [
    {
      position: 'absolute',
      bottom: scale * 3,
      left: scale * 2.83,
      width: scale * 0,
    },

    {
      position: 'absolute',
      bottom: scale * 3 * scaleStep3,
      left: scale * 2.83 * scaleStep3,
      width: scale * 0.9 * scaleStep3,
    },
    {
      position: 'absolute',
      bottom: scale * 3,
      left: scale * 2.83,
      width: scale * 0.9,
    },
    {
      position: 'absolute',
      bottom: scale * 3 * index4WidthAsset,
      left: scale * 2.83 * index4WidthAsset,
      width: scale * 0.9 * index4WidthAsset,
    },
  ];
  const UsernameTradeMarkIconCordinate = [
    {
      position: 'absolute',
      bottom: scale * 0.35,
      left: scale * 3.32,
      width: scale * 0,
    },

    {
      position: 'absolute',
      bottom: scale * 0.35 * scaleStep3,
      left: scale * 3.3 * scaleStep3,
      width: scale * 0.47 * scaleStep3,
    },
    {
      position: 'absolute',
      bottom: scale * 0.35,
      left: scale * 3.3,
      width: scale * 0.47,
    },
    {
      position: 'absolute',
      bottom: scale * 0.35 * index4WidthAsset,
      left: scale * 3.3 * index4WidthAsset,
      width: scale * 0.47 * index4WidthAsset,
    },
  ];
  const SquareCordinate = [
    {
      position: 'absolute',
      bottom: scale * -1.1,
      left: scale * -0.37,
      opacity: 0,
    },

    {
      position: 'absolute',
      bottom: scale * -1.1 * scaleStep3,
      left: scale * -0.37 * scaleStep3,
      opacity: 1,
    },
    {
      position: 'absolute',
      bottom: scale * -1.1,
      left: scale * -0.37,
      opacity: 1,
    },
    {
      position: 'absolute',
      bottom: scale * -1.1 * index4WidthAsset,
      left: scale * -0.37 * index4WidthAsset,
      opacity: 1,
    },
  ];

  const textBenithCordinate = [
    {
      position: 'absolute',
      bottom: scale * -1.6,
      left: scale * -0.37,
      fontSize: scale * 0.24,
      width: 'max-content',
      opacity: 0,
    },

    {
      position: 'absolute',
      bottom: scale * -1.6 * scaleStep3,
      left: scale * -0.37 * scaleStep3,
      fontSize: scale * 0.24 * scaleStep3,
      width: 'max-content',
      opacity: 1,
    },
    {
      position: 'absolute',
      bottom: scale * -1.6,
      left: scale * -0.37,
      fontSize: scale * 0.24,
      width: 'max-content',
      opacity: 1,
    },
    {
      position: 'absolute',
      bottom: scale * -1.97 * index4WidthAsset,
      left: '50%',
      transform: 'translate(-50%,0)',
      fontSize: scale * 0.24,
      width: 'max-content',
      opacity: 1,
    },
  ];

  const CollectivelyCordinate = [
    {
      position: 'absolute',
      bottom: scale * -1.6,
      left: scale * -0.37,
      fontSize: scale * 0.24,
      width: 'max-content',
      opacity: 0,
    },

    {
      position: 'absolute',
      bottom: scale * -1.6,
      left: scale * -0.37,
      fontSize: scale * 0.24,
      width: 'max-content',
      opacity: 0,
    },
    {
      position: 'absolute',
      bottom: scale * -1.6,
      left: scale * -0.37,
      fontSize: scale * 0.24,
      width: 'max-content',
      opacity: 0,
    },
    {
      position: 'absolute',
      bottom: scale * -1.44,
      left: scale * 7.1,
      textAlign: 'center',
      width: scale * 4.5,
      opacity: 1,
    },
  ];

  const textCollectivelyCordinate = [
    {
      position: 'absolute',
      bottom: scale * -1.6,
      left: scale * -0.37,
      fontSize: scale * 0.24,
      width: 'max-content',
      opacity: 0,
    },

    {
      position: 'absolute',
      bottom: scale * -1.6,
      left: scale * -0.37,
      fontSize: scale * 0.24,
      width: 'max-content',
      opacity: 0,
    },
    {
      position: 'absolute',
      bottom: scale * -1.6,
      left: scale * -0.37,
      fontSize: scale * 0.24,
      width: 'max-content',
      opacity: 0,
    },
    {
      position: 'absolute',
      bottom: scale * -2.03,
      left: scale * 8.45,
      fontSize: scale * 0.24,
      textAlign: 'center',
      width: 'max-content',
      opacity: 1,
    },
  ];

  const UnicornCollectivelyCordinate = [
    {
      position: 'absolute',
      bottom: scale * -1.6,
      left: scale * -0.37,
      fontSize: scale * 0.24,
      width: 'max-content',
      opacity: 0,
    },

    {
      position: 'absolute',
      bottom: scale * -1.6,
      left: scale * -0.37,
      fontSize: scale * 0.24,
      width: 'max-content',
      opacity: 0,
    },
    {
      position: 'absolute',
      bottom: scale * -1.6,
      left: scale * -0.37,
      fontSize: scale * 0.24,
      width: 'max-content',
      opacity: 0,
    },
    {
      position: 'absolute',
      bottom: scale * -1.56,
      left: '50%',
      transform: 'translate(-50%,0)',
      textAlign: 'center',
      width: 'max-content',
      opacity: 1,
    },
  ];

  function createArrows1() {
    let elements = [];
    let gap = scale * 0.3;
    for (let i = 0; i < 5; i++) {
      elements.push(
        <img
          key={i}
          src="/images/rectangle.svg"
          alt="path"
          style={{
            width: scale * 0.3,
            position: 'absolute',
            transform: 'rotate(90deg)',
            right: 0,
            bottom: i * gap * 2,
          }}
        />,
      );
    }
    for (let i = 1; i <= 4; i++) {
      elements.push(
        <img
          key={i + 'l'}
          src="/images/rectangle.svg"
          alt="path"
          style={{
            width: scale * 0.29,
            position: 'absolute',
            right: i * gap * 2,
            bottom: 4.12 * gap * 2,
          }}
        />,
      );
    }
    elements.push(
      <img
        key={'a'}
        src="/images/arrow-animate.svg"
        alt="path"
        style={{
          transform: 'rotate(90%)',
          width: scale * 0.8,
          position: 'absolute',
          right: 4 * gap * 2.45,
          bottom: 5 * gap * 1.42,
        }}
      />,
    );
    elements.push(
      <Typography
        className={props.fontStyle}
        key={'$'}
        style={{
          fontSize: scale * 1.4,
          position: 'absolute',
          right: -scale * 0.2,
          bottom: -scale * 1.95,
          color: '#909090',
        }}
      >
        $
      </Typography>,
    );

    return elements;
  }

  function createArrows2() {
    let elements = [];
    let gap = scale * 0.3;
    for (let i = 0; i < 5; i++) {
      elements.push(
        <img
          key={i}
          src="/images/rectangle.svg"
          alt="path"
          style={{
            width: scale * 0.3,
            position: 'absolute',
            transform: 'rotate(90deg)',
            left: 0,
            bottom: i * gap * 2,
          }}
        />,
      );
    }
    for (let i = 1; i <= 4; i++) {
      elements.push(
        <img
          key={i + 'l'}
          src="/images/rectangle.svg"
          alt="path"
          style={{
            width: scale * 0.29,
            position: 'absolute',
            left: i * gap * 2,
            bottom: 4.12 * gap * 2,
          }}
        />,
      );
    }
    elements.push(
      <img
        key={'a'}
        src="/images/arrow-animate2.svg"
        alt="path"
        style={{
          transform: 'rotate(180%)',
          width: scale * 0.8,
          position: 'absolute',
          left: 4 * gap * 2.45,
          bottom: 5 * gap * 1.42,
        }}
      />,
    );
    elements.push(
      <img
        src="/images/people.svg"
        key={'p'}
        style={{
          width: scale * 4.2,
          position: 'absolute',
          left: -scale * 1.92,
          bottom: -scale * 1.95,
        }}
      />,
    );

    return elements;
  }

  useEffect(() => {
    if (index === 1) {
      const container = document.querySelector('.arrowContainer1');
      const elements = Array.from(container.children);
      let index = 0;
      const intervalTime = 90;

      setInterval(() => {
        // Remove highlight class from all elements

        // Skip the last two elements
        if (index < elements.length - 2) {
          // Apply highlight class to the current element
          elements[elements.length - 2].src = '/images/arrow-animate.svg';

          elements[index].classList.add('highlight');
          index++;
        } else {
          if (index < elements.length - 1) {
            elements[index].src = '/images/arrow-animate-white.svg';
            index++;
          } else {
            elements.forEach((el) => el.classList.remove('highlight'));
            // Reset index to 0 to repeat the cycle
            index = 0;
          }
        }
      }, intervalTime);
    }
  }, [index]);

  useEffect(() => {
    if (index === 1) {
      const container = document.querySelector('.arrowContainer2');
      const elements = Array.from(container.children);
      let index = 0;
      const intervalTime = 90;

      setInterval(() => {
        // Remove highlight class from all elements

        // Skip the last two elements
        if (index < elements.length - 2) {
          // Apply highlight class to the current element
          elements[elements.length - 2].src = '/images/arrow-animate2.svg';

          elements[index].classList.add('highlight');
          index++;
        } else {
          if (index < elements.length - 1) {
            elements[index].src = '/images/arrow-animate-white2.svg';
            index++;
          } else {
            elements.forEach((el) => el.classList.remove('highlight'));
            // Reset index to 0 to repeat the cycle
            index = 0;
          }
        }
      }, intervalTime);
    }
  }, [index]);

  return (
    <Box
      sx={{
        margin: `${scale * 1.25}px auto 0`,
        padding: '20px !important',
        position: 'relative',
        width: scale * 4.84,
        height: scale * 5.3,
      }}
    >
      <div style={{ width: scale * 4, height: scale * 5 }}>
        <div style={{ transition: 'all 0.2s ease', ...socialMediaContainerCordinate[index] }}>
          <img
            src={'/images/profilr-pic-empty.svg'}
            alt="Profile pic"
            style={{
              opacity: 0.4,
              transition: 'all 0.2s ease',
              ...profilePicEmptyCordinate[index],
            }}
          />
          <img
            src="/images/username-handle.svg"
            alt="Username handle"
            style={{ opacity: 0.4, transition: 'all 0.2s ease', ...usernameHandleCordinate[index] }}
          />
          <img
            src="/images/tiktok-icon.svg"
            alt="Tiktok icon"
            style={{ opacity: 0.4, transition: 'all 0.2s ease', ...TiktokIconCordinate[index] }}
          />
          <img
            src="/images/youtube-icon.svg"
            alt="Youtube icon"
            style={{ opacity: 0.4, transition: 'all 0.2s ease', ...YoutubeIconCordinate[index] }}
          />
          <img
            src="/images/snapchat-icon.svg"
            alt="Snapchat icon"
            style={{ opacity: 0.4, transition: 'all 0.2s ease', ...SnapchatIconCordinate[index] }}
          />
          <img
            src="/images/instagram-icon.svg"
            alt="Instagram icon"
            style={{ opacity: 0.4, transition: 'all 0.2s ease', ...instagramIconCordinate[index] }}
          />
          <img
            src="/images/x-icon.svg"
            alt="X icon"
            style={{ opacity: 0.4, transition: 'all 0.2s ease', ...XIconCordinate[index] }}
          />
          <img
            src="/images/facebook-icon.svg"
            alt="Facebook icon"
            style={{ opacity: 0.4, transition: 'all 0.2s ease', ...FacebookIconCordinate[index] }}
          />
          <img
            src="/images/social-icon.svg"
            alt="Social media icon"
            style={{ opacity: 0.4, transition: 'all 0.2s ease', ...SocialIconCordinate[index] }}
          />
          <img
            src="/images/trade-mark.svg"
            alt="Trade mark icon"
            style={{ transition: 'all 0.2s ease', ...ProfileTradeMarkIconCordinate[index] }}
          />
          <img
            src="/images/trade-mark.svg"
            alt="Trade mark icon"
            style={{ transition: 'all 0.2s ease', ...UsernameTradeMarkIconCordinate[index] }}
          />
          <div
            style={{
              opacity: 0.4,
              width:
                index !== 1
                  ? index !== 3
                    ? scale * 4.84
                    : scale * 4.84 * index4WidthAsset
                  : scale * 4.84 * scaleStep3,
              height:
                index !== 1
                  ? index !== 3
                    ? scale * 5.3
                    : scale * 5.3 * index4WidthAsset
                  : scale * 5.3 * scaleStep3,
              padding:
                index !== 1
                  ? index !== 3
                    ? scale * 0.15
                    : scale * 0.15 * index4WidthAsset
                  : scale * 0.15 * scaleStep3,
              transition: 'all 0.2s ease',
              border: `${
                index !== 1
                  ? index !== 3
                    ? scale * 0.07
                    : scale * 0.07 * index4WidthAsset
                  : scale * 0.07 * scaleStep3
              }px solid #ffffff66`,
              borderRadius: scale * 0.17,
              ...SquareCordinate[index],
            }}
          >
            <div
              style={{
                width: '100%',
                height: '100%',
                transition: 'all 0.2s ease',
                border: `${
                  index !== 1
                    ? index !== 3
                      ? scale * 0.07
                      : scale * 0.07 * index4WidthAsset
                    : scale * 0.07 * scaleStep3
                }px solid #ffffff66`,
              }}
            />
          </div>
          {index !== 1 && (
            <Typography
              className={props.fontStyle}
              style={{
                position: 'absolute',
                color: index !== 3 ? '#ffffff66' : '#ffbf12',
                ...textBenithCordinate[index],
              }}
            >
              {index !== 3 ? 'personal brand startup company' : 'Individually'}
            </Typography>
          )}
        </div>
        {index === 1 && (
          <div
            className="arrowContainer1"
            style={{
              position: 'absolute',
              right: -scale * 0.4 * 10,
              bottom: '-35%',
              width: scale * 0.5 * 15,
              height: scale * 0.5 * 15,
            }}
          >
            {createArrows1()}
          </div>
        )}
        {index === 1 && (
          <div
            className="arrowContainer2"
            style={{
              position: 'absolute',
              left: -scale * 0.4 * 10,
              bottom: '-35%',
              width: scale * 0.5 * 15,
              height: scale * 0.5 * 15,
            }}
          >
            {createArrows2()}
          </div>
        )}
        {index === 1 && (
          <div
            style={{
              display: 'flex',
              justifyContent: 'center',
              alignItems: 'end',
              width: scale * 26,
              position: 'absolute',
              bottom: -scale * 5.25,
              left: scale * 2.5,
              transform: 'translate(-50%,0)',
            }}
          >
            <div
              className={props.fontStyle}
              style={{
                textAlign: 'right',
                width: scale * 2.5,
                color: '#ffbf12',
                fontSize: '18px',
                lineHeight: '18px',
                padding: '0 20px 0 0',
              }}
            >
              {unicornRatio.worth}{' '}
            </div>
            <div style={{ position: 'relative' }}>
              <p
                className={props.fontStyle}
                style={{
                  fontSize: '16px',
                  lineHeight: '16px',
                  position: 'absolute',
                  left: '50%',
                  top: '-24px',
                  transform: 'translate(-50%,0)',
                  margin: 0,
                  color: '#ffbf12',
                }}
              >
                {' '}
                {Math.ceil(unicornRatio.ratio)}%
              </p>{' '}
              <div
                className="MyBrandStats__IpoProgressSlider"
                style={{
                  diaplay: 'flex',
                  alignItems: 'center',
                  border: '1px solidx #fff',
                  borderRadius: scale * 4,
                  height: '17px',
                  width: scale * 13,
                }}
              >
                <div
                  style={{
                    position: 'relative',
                    background: '#ffbf12',
                    padding: '0 1px',
                    margin: 0,
                    borderRadius: '50px',
                    height: unicornRatio.ratio > 1.15 ? '15px' : '11px',
                    width: `${unicornRatio.ratio}%`,
                    transition: 'width 0.5s ease-out 0s',
                  }}
                />
              </div>
            </div>
            <div style={{ display: 'inline-flex', alignItems: 'center', width: '170px' }}>
              <div
                style={{
                  display: 'inline-flex',
                  // flexDirection: 'column',
                  alignItems: 'flex-end',
                  marginLeft: '10px',
                }}
              >
                <img src="/images/unicorn-line-icon.svg" alt="Unicorn" style={{ width: '50px', opacity: 0.6 }} />
                <p
                  className={props.fontStyle}
                  style={{
                    color: '#ffffff66',
                    fontSize: '14px',
                    lineHeight: '16px',
                    margin: '0',
                    width: scale * 3,
                    marginLeft: '10px',
                  }}
                >
                  $1B social media
                  <br /> Personal brand
                </p>
              </div>
            </div>
          </div>
        )}

        {index === 2 && (
          <img
            src="/images/trademark-figure1.png"
            style={{
              opacity: 0.8,
              width: scale * 7,
              position: 'absolute',
              left: -scale * 8.3,
              top: scale * 2.5,
            }}
          />
        )}

        <img
          src="/images/collectively.svg"
          alt="Collectively"
          style={{ transition: 'all 0.2s ease', ...CollectivelyCordinate[index] }}
        />
        <Typography
          className={props.fontStyle}
          style={{ position: 'absolute', color: '#ffbf12', ...textCollectivelyCordinate[index] }}
        >
          Collectively
        </Typography>

        <div
          style={{
            display: 'flex',
            flexDirection: 'column',
            alignItems: 'center',
            transition: 'all 0.2s ease',
            ...UnicornCollectivelyCordinate[index],
          }}
        >
          <img
            src="/images/big-arrow.png"
            style={{
              position: 'absolute',
              top: '43%',
              left: scale * 4.15,
              transform: 'translate(0,-50%)',
              width: scale * 1.52,
            }}
          />
          <img
            src="/images/unicorn-line-yellow-icon.svg"
            alt="Collectively"
            style={{ width: scale * 1.8, marginBottom: scale * 0.2 }}
          />
          <Typography
            className={props.fontStyle}
            style={{
              color: '#ffbf12',
              fontSize: scale * 0.4,
            }}
          >
            $1B social media <br />
            Personal brand
          </Typography>
          <img
            src="/images/arrow-animate2.svg"
            style={{
              position: 'absolute',
              top: '43%',
              left: scale * -1.3,
              transform: 'translate(0,-50%)',
              width: scale * 0.72,
            }}
          />
        </div>
      </div>
    </Box>
  );
}
export default withWidth()(PersonalBrandAnimate);
